import { useGetAllPuzzleItemsQuery } from 'src/api/puzzle-item/getPuzzleItems';

export const ItemsByCategory = ({ categoryId }: { categoryId: number }) => {
  const { data: puzzleItems } = useGetAllPuzzleItemsQuery();

  const items = puzzleItems?.filter((item) => item.categoryId === categoryId);

  return (
    <>
      {items?.map((item) => (
        <li key={item.id}>
          ({item.id}) {item.name}
        </li>
      ))}
    </>
  );
};
